'use client'

import { ComponentProps } from 'react'
import { IMAGE_PATH } from '../../config/constants'
import Posts from './posts'
import SectionTitle from '../../components/section-title'

type Props = Pick<ComponentProps<typeof Posts>, 'posts'> & {
    sectionTitleProps?: Partial<ComponentProps<typeof SectionTitle>>
}

const NewsSection = ({ posts, sectionTitleProps }: Props) => {
    return (
        <section id="recent-news">
            <SectionTitle 
                title="Recent News" 
                src={`${IMAGE_PATH}/stickers/computer.gif`}
                {...sectionTitleProps}
            />

            <Posts posts={posts} />
        </section>
    )
}

export default NewsSection
